import { PermisosService } from './../providers/authentication/permisos.service';
import { IdiomaService } from './../providers/idioma/idioma.service';
import { Component, EventEmitter, Input, Output, Inject, forwardRef, OnDestroy, OnChanges, SimpleChanges} from '@angular/core';
import { EntityManagerProvider } from '../providers/entity-manager-provider/entity-manager-provider';
import { AuthenticationService } from '../providers/authentication/authentication.service';
import { ConexionFormulario, ConexionNodoIdiomaFormulario } from '../domain/ConexionFormulario';
import { Constantes } from '../domain/constantes';
import { Idioma } from '../domain/Idioma';
import {TranslatePipe, TranslateService, LangChangeEvent} from 'ng2-translate';
import { Permisos } from '../providers/authentication/permisos.service';
import { AppComponent } from '../app.component';

@Component({
  selector: 'app-formulario-conexion',
  templateUrl: './FormularioConexion.component.html'
})

export class FormularioConexionComponent implements OnDestroy, OnChanges{

  @Input() conexionSeleccionada: ConexionFormulario = new ConexionFormulario();
  @Input() conexionSeleccionadaVuelta: ConexionFormulario = new ConexionFormulario();
  @Input() perfilesMovilidad: any;
  @Input() edicion: boolean;
  @Input() confirmacionVisible: boolean;
  @Input() displayDialogEditarNodo: boolean;
  @Input() msgs: any[];
  @Input() visible: boolean = true;

  @Output() onElementoGuardado: EventEmitter <any> = new EventEmitter();
  @Output() onElementoError: EventEmitter <any> = new EventEmitter();
  @Output() onElementoEliminado: EventEmitter <any> = new EventEmitter();
  @Output() onFormularioValidation: EventEmitter <boolean> = new EventEmitter();

  public isValid = true;
  public operacion;

	/* IDIOMA */
	idiomas;
	idiomaSeleccionado: Idioma;
	idiomaDefecto: Idioma;

	permisos: Permisos = new Permisos();

	spinner: HTMLElement;

	constructor(
		private appComponent: AppComponent,
		private entityManagerProvider: EntityManagerProvider,
		public authService: AuthenticationService,
			public idiomaService: IdiomaService,
			private translate: TranslateService,
			private permisosService: PermisosService) {
			const that = this;
			// Inicializamos Spinner
			this.spinner = document.getElementsByClassName('spinner-container')[0] as HTMLElement;
			this.spinner.style.display = 'none';

			this.entityManagerProvider.getIDIOMA()
			.then(function (idiomasENTIDAD: any) {

				that.idiomas = [];
				idiomasENTIDAD.forEach(idioma => {
					if(idioma.Visible === true){
					that.idiomas.push(new Idioma(idioma));
					}
				});

				that.idiomaDefecto = that.idiomaService.getIdiomaDefecto(that.idiomas);
				that.idiomaSeleccionado = that.idiomaDefecto;

				return that.comprobarPermisos();
			});
	}

	ngOnChanges(changes: SimpleChanges): void {
		this.idiomaSeleccionado = this.idiomaDefecto;
		this.onIdiomaChange({value: this.idiomaSeleccionado});
	}

	ngOnDestroy(): void {
		this.entityManagerProvider.RejectChanges();
	}

	comprobarPermisos() {
		const userId = this.authService.getIdUsuario();
		const that = this;
		return this.permisosService.getPermisosUsuario(userId)
		.then(function(perm){
			that.permisos = perm;
		});
	}

	setPesoMaximo(peso_conexion){
		peso_conexion.Peso = '∞';
		console.log('peso_conexion: ' + peso_conexion.Peso);
	}

/* ************************************************************************** */
/*                            COMUN FORMULARIO                                */
/* ************************************************************************** */

	inputChanged(value) {

		//  Cojemos la traduccion del conexionNodo al idioma seleccionado
		const conexionNodoIdioma = this.conexionSeleccionada.Idiomas.get(this.idiomaSeleccionado.ENTIDAD.Codigo);
		// Guardamos los posibles cambios del idioma
		conexionNodoIdioma.Indicacion = this.conexionSeleccionada.Indicacion;
		this.conexionSeleccionada.Idiomas.set(this.idiomaSeleccionado.ENTIDAD.Codigo, conexionNodoIdioma);

		//  Cojemos la traduccion del conexionNodo de vuelta al idioma seleccionado
		const conexionNodoVuelta = this.conexionSeleccionadaVuelta.Idiomas.get(this.idiomaSeleccionado.ENTIDAD.Codigo);
		// Guardamos los posibles cambios del idioma
		conexionNodoVuelta.Indicacion = this.conexionSeleccionadaVuelta.Indicacion;
		this.conexionSeleccionadaVuelta.Idiomas.set(this.idiomaSeleccionado.ENTIDAD.Codigo, conexionNodoVuelta);

	}

	public esEdicion(): boolean {
		return this.conexionSeleccionada && (this.conexionSeleccionada.Id ? true : false);
		// return this.edicion;
	}

	public validar(): boolean {
		console.warn('Implementar: validar');
		if (this.conexionSeleccionada.Indicacion === '' || this.conexionSeleccionada.Indicacion === undefined) {
			this.isValid = false;
		}
		else {
			this.isValid = true;
		}

		this.onFormularioValidation.emit(this.isValid);

		return this.isValid;
	}

	public guardar(): any {
		if (this.validar()) {

			if (!this.esEdicion()) {
				this.guardarNuevo();
			}
			else{
			this.guardarEdicion();
			}

		} else {
			this.appComponent.showError( this.translate.instant('MensajesConfirmacion.MENSAJE_FORMULARIO_NO_VALIDO') );
			console.log('Formulario no completo!');
		}

	}

	public guardarNuevo () {
	}

	public guardarEdicion () {
		const that = this;

		that.guardarMultiIdioma()
		.then(function(msg) {
			console.log(that.conexionSeleccionada)
			console.log(that.conexionSeleccionadaVuelta)
			// Editamos Conexion de Ida
			const conexionNodoIdioma = that.conexionSeleccionada.Idiomas.get(that.idiomaDefecto.ENTIDAD.Codigo);
			that.conexionSeleccionada.Indicacion = conexionNodoIdioma.Indicacion ? conexionNodoIdioma.Indicacion : '';


			that.conexionSeleccionada.ENTIDAD.Indicacion = that.conexionSeleccionada.Indicacion;
			that.conexionSeleccionada.ENTIDAD.CortadoTemporalmente = that.conexionSeleccionada.CortadoTemporalmente;
			that.conexionSeleccionada.ENTIDAD.CoordenadasCamino = JSON.stringify(that.conexionSeleccionada.CONEXION_PLANO.getRuta());

			for (let index = 0; index < that.conexionSeleccionada.PESO_CONEXIONS.length; index++) {
				const peso_conexion = that.conexionSeleccionada.PESO_CONEXIONS[index];
				if (peso_conexion.Peso === '∞') {
					that.conexionSeleccionada.ENTIDAD.PESO_CONEXIONS[index].Peso = Constantes.MAX_PESO;
				}
				else{
					that.conexionSeleccionada.ENTIDAD.PESO_CONEXIONS[index].Peso = peso_conexion.Peso;
				}
			}

			// Editamos Conexion de Vuelta
			const conexionNodoVuelta = that.conexionSeleccionadaVuelta.Idiomas.get(that.idiomaDefecto.ENTIDAD.Codigo);
			that.conexionSeleccionadaVuelta.Indicacion = conexionNodoVuelta.Indicacion ? conexionNodoVuelta.Indicacion : '';

			that.conexionSeleccionadaVuelta.ENTIDAD.Indicacion = that.conexionSeleccionadaVuelta.Indicacion;
			that.conexionSeleccionadaVuelta.ENTIDAD.CortadoTemporalmente = that.conexionSeleccionada.CortadoTemporalmente;
			let arrayRutasIda = that.conexionSeleccionada.CONEXION_PLANO.getRuta();
			
			if(arrayRutasIda !== null){
				let arrayRutasIdaInvertidas = [...arrayRutasIda].reverse();
				that.conexionSeleccionadaVuelta.ENTIDAD.CoordenadasCamino = JSON.stringify(arrayRutasIdaInvertidas);
				that.conexionSeleccionadaVuelta.CONEXION_PLANO.setRuta(arrayRutasIdaInvertidas);
			}

			
			for (let index = 0; index < that.conexionSeleccionadaVuelta.PESO_CONEXIONS.length; index++) {

				const peso_conexion = that.conexionSeleccionadaVuelta.PESO_CONEXIONS[index];
				if (peso_conexion.Peso === '∞') {
					that.conexionSeleccionadaVuelta.ENTIDAD.PESO_CONEXIONS[index].Peso = Constantes.MAX_PESO;
				}
				else{
					that.conexionSeleccionadaVuelta.ENTIDAD.PESO_CONEXIONS[index].Peso = peso_conexion.Peso;
				}

			}

			return that.entityManagerProvider.saveChanges();
		})
		.then(function(msg) {
			that.onElementoGuardado.emit({ result: true, element: [that.conexionSeleccionada, that.conexionSeleccionadaVuelta] });
			that.spinner.style.display = 'none';
			return msg;
		})
		.then(function(data: any) {
			console.log(data)
			// Renovamos el Token
			if(data.httpResponse.status === 200){
				that.authService.relogin();
			}
		})
		.catch(function(err) {
			console.log(err)
			that.onElementoGuardado.emit({ result: false, element: [that.conexionSeleccionada, that.conexionSeleccionadaVuelta]});
			that.spinner.style.display = 'none';
			return err;
		});
	}

	guardarMultiIdioma(){
		const that = this;
		this.entityManagerProvider.deleteEntityArray(this.conexionSeleccionada.ENTIDAD.IDIOMAS);
		this.entityManagerProvider.deleteEntityArray(this.conexionSeleccionadaVuelta.ENTIDAD.IDIOMAS);

		return this.entityManagerProvider.newCONEXION_NODOS_IDIOMA(this.conexionSeleccionada.ENTIDAD)
		.then(function(CONEXION_IDIOMAs){

			CONEXION_IDIOMAs.forEach(CONEXION_IDIOMA => {
				const aux = that.conexionSeleccionada.Idiomas.get(CONEXION_IDIOMA.IDIOMA.Codigo);
				if (aux) {
					CONEXION_IDIOMA.Indicacion = aux.Indicacion;

				}
			});
			return that.entityManagerProvider.newCONEXION_NODOS_IDIOMA(that.conexionSeleccionadaVuelta.ENTIDAD);
		})
		.then(function(CONEXION_IDIOMAs){

			CONEXION_IDIOMAs.forEach(CONEXION_IDIOMA => {
				const aux = that.conexionSeleccionadaVuelta.Idiomas.get(CONEXION_IDIOMA.IDIOMA.Codigo);
				if (aux) {
					CONEXION_IDIOMA.Indicacion = aux.Indicacion;
				}

			});

		});

	}

	public eliminar() {
		const that = this;
		//this.spinner.style.display = 'inherit';
		this.eliminarSeleccionado()
		.then(function () {
			that.onElementoEliminado.emit({ result: true, element: [that.conexionSeleccionada, that.conexionSeleccionadaVuelta] });
		})
		.catch(function () {
			that.onElementoEliminado.emit({ result: false, element: [that.conexionSeleccionada, that.conexionSeleccionadaVuelta] });

		});
	}

	public eliminarSeleccionado () {
		const that = this;
		if (this.conexionSeleccionada !== undefined) {
			that.authService.relogin();
			return this.entityManagerProvider.deleteCascadaCONEXIONES_NODO(
				[this.conexionSeleccionada.ENTIDAD, this.conexionSeleccionadaVuelta.ENTIDAD]
			);

		}
	}

	/* Confirmacion */
	mostrarConfirmacion(operacion){
		this.appComponent.showWarn(operacion);
		this.operacion = operacion;
		this.confirmacionVisible = true;
	}

	confirmar(){
		this.msgs = [];
		this.spinner.style.display = 'inherit';
		if (this.operacion === 'guardar') {
			this.guardar();

		}
		else if (this.operacion === 'eliminar'){
			this.eliminar();
		}
	}

	cancelar(){
		this.msgs = [];
		this.operacion = '';
		this.confirmacionVisible = false;
	}

	onIdiomaChange($event) {
		const idioma = $event.value;
		if (!idioma) {
			return;
		}
		this.idiomaSeleccionado = idioma;

		// CONEXION IDA
		// Cojemos la traduccion del conexionNodo al idioma seleccionado
		let conexionNodoIdioma = this.conexionSeleccionada.Idiomas.get(idioma.value);

		// Si no existe la creamos
		if (!conexionNodoIdioma) {
			conexionNodoIdioma = new ConexionNodoIdiomaFormulario();
			this.conexionSeleccionada.Idiomas.set(idioma.value, conexionNodoIdioma);
		}

		// Seteamos los valores de conexionNodoFormulario con los valores del idioma seleccionado
		this.conexionSeleccionada.Indicacion = conexionNodoIdioma.Indicacion;


		// CONEXION VUELTA
		// Cojemos la traduccion del conexionNodo al idioma seleccionado
		let conexionVuelta = this.conexionSeleccionadaVuelta.Idiomas.get(idioma.value);

		// Si no existe la creamos
		if (!conexionVuelta) {
			conexionVuelta = new ConexionNodoIdiomaFormulario();
			this.conexionSeleccionadaVuelta.Idiomas.set(idioma.value, conexionVuelta);
		}

		// Seteamos los valores de conexionNodoFormulario con los valores del idioma seleccionado
		this.conexionSeleccionadaVuelta.Indicacion = conexionVuelta.Indicacion;

		console.log('Cambiar Titulo y descripcion a la del idioma: ' + idioma.value + '(' + idioma.title + ')');
	}

}



// WEBPACK FOOTER //
// C:/Users/adri9/Escritorio/admin-everpath/src/app/formularios/FormularioConexion.component.ts